import { Component, signal } from '@angular/core';
import { RgserviceService } from '../../../Services/RGService/rgservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RgsharedserviceService } from '../../../Services/RGService/rgsharedservice.service';
import { v4 as uuidv4 } from 'uuid'; 
import { IpService } from '../../../Services/CADServices/ip.service';
import { CadService } from '../../../Services/CADServices/cad.service';
import { SharedDataService } from '../../../Services/SharedServices/shared-data.service';
import { environment } from '../../../../Environment/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-rg-second-selection',
  templateUrl: './rg-second-selection.component.html',
  styleUrl: './rg-second-selection.component.css'
})
export class RgSecondSelectionComponent {
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  AssetbasePath:any;
  constructor(private sharedDataService: SharedDataService,private rgService:RgserviceService,private formBuilder:FormBuilder,private rgSharedService:RgsharedserviceService,private ipService:IpService,private cadService: CadService, private router: Router) {
    this.AssetbasePath = environment.assetsPath;
  }

  public reducerSelectionForm!: FormGroup;
  formSubmitted = false;
  inputUnitVersion:any;
  inputTypeOfUnit:any;
  inputOutputShaft:any;
  inputHandOfAssembly:any;
  inputMotorAdaptor:any;
  inputSpecialFeature:any;
  productCode:any;
  isMotorAdaptorDisabled: boolean = false;
  // rgImage=Document.getElementById("rgImage")
  specData:any={};
  AccuSpecModel:any={
    Weight_lb:"",
    Weight_kg:"",
  };
  finalData:any={
    location:"",
    code:""
  };
 
  size:any;
  ratio:any;
  speed:any;
  typeOfUnit:any;
  CADfileFormat={
    CAD2DFileFormat:'.dxf',
    CAD3DFileFormat:'.stp',
  };
  rgReducerSelectionForm = this.formBuilder.group({
    inputUnitVersion:[null, Validators.required],
    inputTypeOfUnit:[null, Validators.required],
    inputOutputShaft:[null, Validators.required],
    inputHandOfAssembly:[null,Validators.required],
    inputMotorAdaptor:[null,Validators.required],
    inputSpecialFeature:[null,Validators.required],
  });
  
public showcdinfo: boolean = false;
public showspinfo: boolean = false;
ngOnInit(){

  const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools'))
  {
    this.showspinfo = true;
    this.showcdinfo = false;
  }
  else
  {
    this.showspinfo = false;
    this.showcdinfo = true;
  }
  // this.updateMotorAdaptorValidators();
  this.rgSharedService.size$.subscribe((sizeData:any) => 
    {
      // this.size = sizeData.size.replace(/[a-zA-Z]/g, '');
      console.log("Data of set size rato and speed", sizeData);
      this.size = sizeData.size;
      this.ratio = sizeData.ratio;
      this.speed = sizeData.speed;
      this.getUnitVersion();
    });

    this.rgSharedService.specification$.subscribe((specificationData:any) => 
      {
        this.specData= specificationData;
        console.log("I am in Data", this.specData);
      });



}
assembleCode={
    series:"RG",
    size:"",
    revision:"1",
    ratio:"",
    untiversion:"",
    typeofunit:"",
    outputshaft:"",
    inputspeed:"",
    assemblyposition:"",
    motoradaptor:"",
    specialfeature:""
};
private getUnitVersion():void{
  this.signalStatus=true;
  this.panelOpenState = signal(this.signalStatus);
 this.rgService.getUnitVersion().subscribe(result=>{
    this.inputUnitVersion = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Unit Version", this.inputUnitVersion);
 },
(error)=>{
  console.error('Error fetching in unitversion :', error);
});
}
private getTypeOfUnit(size:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/RGImages/RG.jpg";
  this.rgService.getTypeOfUnit(size).subscribe(result=>{
    this.inputTypeOfUnit = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Unit Type", result);
  },
  (error)=>{
    console.error('Error fetching in type of unit :', error);
  });
}
private getOutputShaft(size:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/RGImages/OutputShaft.jpg";
  this.rgService.getOutputShaft(size).subscribe(result=>{
    this.inputOutputShaft = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Output Shaft", result);
  },
  (error)=>{
    console.error('Error fetching in Output Shaft :', error);
  });
}
private getAssemblyPosition(outputshaft:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/RGImages/RG.jpg";
  this.rgService.getAssemblyPosition(outputshaft).subscribe(result=>{
    this.inputHandOfAssembly = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Assembly Position", result);
  },
  (error)=>{
    console.error('Error fetching in assembly position :', error);
  });
}
private getMotorAdaptor(typeOfUnit:any,size:any){
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/RGImages/RG.jpg";
  this.rgService.getMotorAdaptor(typeOfUnit,size).subscribe(result=>{
  this.inputMotorAdaptor = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Motor Adaptor", result);
  },
  (error)=>{
    console.error('Error fetching in motor adaptor :', error);
  });
}
private getSpecialfeature(){
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/RGImages/RG.jpg";
  this.rgService.getSpecialfeature().subscribe(result=>{
    this.inputSpecialFeature = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
 },
(error)=>{
  console.error('Error fetching in special feature :', error);
});
}
onUnitVersionChange(event: any){
this.assembleCode.untiversion = event.target.value;
this.getTypeOfUnit(this.size);
this.resetDependentDropdowns(['inputTypeOfUnit']);
}

onTypeOfUnitChange(event:any){
  this.assembleCode.typeofunit = event.target.value;
  this.typeOfUnit = event.target.value;
this.getOutputShaft(this.size);
this.resetDependentDropdowns(['inputOutputShaft']);
}

oninputOutputShaftChange(event:any){
  debugger;
  this.assembleCode.outputshaft = event.target.value;
this.getAssemblyPosition(event.target.value);
this.resetDependentDropdowns(['inputHandOfAssembly']);
}



oninputHandOfAssemblyChange(event:any){
  this.assembleCode.assemblyposition = event.target.value;
  const motorEle = document.getElementById("inputMotorAdaptor") as HTMLInputElement;
  if(this.typeOfUnit=="R"){
    this.isMotorAdaptorDisabled=true;
    this.rgReducerSelectionForm.get('inputMotorAdaptor')?.setValue(null);
    motorEle.disabled = true;
    this.getSpecialfeature();
  }else{
    
    if(motorEle.disabled == true){
      motorEle.disabled = false;
    }
    
    this.getMotorAdaptor(this.typeOfUnit,this.size);
  }
  this.resetDependentDropdowns(['inputSpecialFeature']);
}
oninputMotorAdaptorChange(event:any){
  this.assembleCode.motoradaptor=event.target.value;
this.getSpecialfeature();
}

oninputSpecialFeatureChange(event:any){
  
this.assembleCode.specialfeature = event.target.value;
}

private resetDependentDropdowns(dropdownNames: string[]) {
  dropdownNames.forEach(name => {
    this.rgReducerSelectionForm.get(name)?.reset();
  });
}

rgReducerButton(){
  debugger;
  this.updateSpecification();
  this.updateMotorAdaptorValidators();
  this.getAllproductDetail();
  this.formSubmitted = true;
  // if(this.assembleCode.typeofunit=="R"){
  //   this.assembleCode.motoradaptor="";
  // }
  if((this.speed=="580") || (this.speed=="720") || (this.speed=="870")){
    this.assembleCode.inputspeed = "C";
  }else{
    this.assembleCode.inputspeed = "D";
  }
  if(this.ratio.length==1){
    this.assembleCode.ratio = this.ratio+".0";
  }else if(this.ratio.length==2){
    this.assembleCode.ratio = this.ratio+".";
  }
  if(this.assembleCode.typeofunit=="R"){
    this.productCode = this.assembleCode.series + this.size + this.assembleCode.revision + this.assembleCode.ratio
                        + this.assembleCode.untiversion + this.assembleCode.typeofunit + this.assembleCode.outputshaft
                        + this.assembleCode.inputspeed + this.assembleCode.assemblyposition + "----"+this.assembleCode.specialfeature;
  }else{
    this.productCode = this.assembleCode.series + this.size + this.assembleCode.revision + this.assembleCode.ratio
                        + this.assembleCode.untiversion + this.assembleCode.typeofunit + this.assembleCode.outputshaft
                        + this.assembleCode.inputspeed + this.assembleCode.assemblyposition + this.assembleCode.motoradaptor + "----"+this.assembleCode.specialfeature;
  }
  console.log("Product Code:", this.productCode);
  this.rgSharedService.setProductCode(this.productCode);
  this.sharedDataService.setCADChangeStatus("true");
  this.createCAD();
}





updateMotorAdaptorValidators() {
  const control:any = this.rgReducerSelectionForm.get('inputMotorAdaptor');
  if (this.isMotorAdaptorDisabled) {
    control.clearValidators();
  } else {
    control.setValidators(Validators.required);
  }
  control.updateValueAndValidity(); // Update the control's value and validity
}



createCAD(): void {
  debugger;
  const cadData={
    Website:"Accudrive_New",
    Guid: uuidv4(),
    Code:this.productCode.toString().trim(),
    asmFormat:this.CADfileFormat.CAD3DFileFormat.toString().trim(),
    dwgFormat:this.CADfileFormat.CAD2DFileFormat.toString().trim(),
    MotorFrame: "",
    FlangType:"",
    ShaftDia:"",
    TimeIn:this.getCurrentFormattedDate(),
    ClientIP:"10.248.24.1"
  };
  debugger;
  // this.finalData.cadLocation = cadData.Guid;
  this.finalData.location = cadData.Guid;
  this.finalData.code = cadData.Code;
  this.rgSharedService.setCadData(this.finalData);
  this.cadService.GenerateCADLoadbalancing(cadData);

  }

getCurrentFormattedDate(): string {
  const now = new Date();

  // Helper function to pad single-digit numbers with leading zero
  const dateData = (num: number) => num.toString().padStart(2, '0');

  return `${now.getFullYear()}-${dateData(now.getMonth() + 1)}-${dateData(now.getDate())}T${dateData(now.getHours())}:${dateData(now.getMinutes())}:${dateData(now.getSeconds())}`;
}

updateSpecification(){
  const unitversion = document.getElementById("inputUnitVersion") as HTMLInputElement;
  const OutputShaft = document.getElementById("inputOutputShaft") as HTMLSelectElement;
  switch(unitversion.value){
        case "S":
          switch(this.specData.size.replace(/[a-zA-Z]/g, '')){
            case "15":
              this.specData.backlash="27";
              break;
            case "20":
                this.specData.backlash = "17";
                break;
            case "25":
                this.specData.backlash = "14";
                break;
            case "30":
                this.specData.backlash = "11";
                break;
            case "35":
                this.specData.backlash = "11";
                break;
          }
          break;
        case "L":
          switch(this.specData.size.replace(/[a-zA-Z]/g, '')){
            case "15":
                  this.specData.backlash = "11";
                  break;
              case "20":
                  this.specData.backlash = "8";
                  break;
              case "25":
                  this.specData.backlash = "7";
                  break;
              case "30":
                  this.specData.backlash = "5";
                  break;
              case "35":
                  this.specData.backlash = "4";
                  break;
          }
          break;
      }
  
  this.GetWeightslb(OutputShaft.options[OutputShaft.selectedIndex].text, this.specData.size)
  this.GetWeightskg(OutputShaft.options[OutputShaft.selectedIndex].text, this.specData.size)
  this.rgSharedService.setFinalSpecification(Object.assign({}, this.specData, this.AccuSpecModel))
  // console.log("Combined Data", Object.assign({}, this.specData, this.AccuSpecModel) );
}




private GetWeightslb(OutputShaft:any, size:any):string
{
    if (OutputShaft.includes("Hollow"))
    {
      // switch(code){
      //   case "15":

      // }
        if (size=="RG15")
        {
            this.AccuSpecModel.Weight_lb = "15";
        }
        else if (size=="RG20")
        {
            this.AccuSpecModel.Weight_lb = "27";
        }
        else if (size=="RG25")
        {
            this.AccuSpecModel.Weight_lb = "44";
        }
        else if (size=="RG30")
        {
            this.AccuSpecModel.Weight_lb = "78";
        }
        else if (size=="RG35")
        {
            this.AccuSpecModel.Weight_lb = "116";
        }
    }
    else if (OutputShaft.includes("Solid") || OutputShaft.includes("Extended"))
    {
        if (size=="RG15")
        {
            this.AccuSpecModel.Weight_lb = "16";
        }
        else if (size=="RG20")
        {
            this.AccuSpecModel.Weight_lb = "28";
        }
        else if (size=="RG25")
        {
            this.AccuSpecModel.Weight_lb = "45";
        }
        else if (size=="RG30")
        {
            this.AccuSpecModel.Weight_lb = "73";
        }
        else if (size=="RG35")
        {
            this.AccuSpecModel.Weight_lb = "112";
        }
    }
    return this.AccuSpecModel.Weight_lb;
}

private GetWeightskg(OutputShaft:any, size:any):string
{
    
    if (OutputShaft.includes("Hollow"))
    {
        if (size=="RG15")
        {
          this.AccuSpecModel.Weight_kg = "6.8";
        }
        else if (size=="RG20")
        {
            this.AccuSpecModel.Weight_kg = "12.2";
        }
        else if (size=="RG25")
        {
            this.AccuSpecModel.Weight_kg = "20.0";
        }
        else if (size=="RG30")
        {
            this.AccuSpecModel.Weight_kg = "35.4";
        }
        else if (size=="RG35")
        {
            this.AccuSpecModel.Weight_kg = "52.6";
        }
    }
    else if (OutputShaft.includes("Solid") || OutputShaft.includes("Extended"))
    {
        if (size=="RG15")
        {
            this.AccuSpecModel.Weight_kg = "7.3";
        }
        else if (size=="RG20")
        {
            this.AccuSpecModel.Weight_kg = "12.7";
        }
        else if (size=="RG25")
        {
            this.AccuSpecModel.Weight_kg = "20.4";
        }
        else if (size=="RG30")
        {
            this.AccuSpecModel.Weight_kg = "33.1";
        }
        else if (size=="RG35")
        {
            this.AccuSpecModel.Weight_kg = "50.8";
        }
    }
    return this.AccuSpecModel.Weight_kg;
}
getAllproductDetail(){
  const unitversion = document.getElementById("inputUnitVersion") as HTMLSelectElement;
  const typeOfUnit = document.getElementById("inputTypeOfUnit") as HTMLSelectElement;
  const OutputShaft = document.getElementById("inputOutputShaft") as HTMLSelectElement;
  const handOfAssembly = document.getElementById("inputHandOfAssembly") as HTMLSelectElement;
  const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLSelectElement;
  const specialFeature = document.getElementById("inputSpecialFeature") as HTMLSelectElement;
 var speed="";
 var ratio="";
 if(this.speed){
  switch(this.speed){
    case "580":
      speed = "C - Input Speed 580 RPM";
      break;
    case "720":
      speed = "C - Input Speed 720 RPM";
      break;
    case "870":
      speed = "C - Input Speed 870 RPM";
      break;
    case "1150":
      speed = "D - Input Speed 1150 RPM";
      break;
    case "1450":
      speed = "D - Input Speed 1450 RPM";
      break;
    case "1750":
      speed = "D - Input Speed 1750 RPM";
      break;
  }
 }
 if(this.ratio.length==1){
  ratio = this.ratio+".0";
}else if(this.ratio.length==2){
  ratio = this.ratio+".";
}
  const prodDetails={
    size:this.size,
    ratio: ratio.replace(/\.$/, ''),
    unitversion: unitversion.options[unitversion.selectedIndex].text.replace(/^.*? - /, ''),
    unitversionValue:unitversion.value,
    typeOfUnit: typeOfUnit.options[typeOfUnit.selectedIndex].text.replace(/^.*? - /, ''),
    typeOfUnitValue: typeOfUnit.value,
    OutputShaft: OutputShaft.options[OutputShaft.selectedIndex].text.replace(/^.*? - /, ''),
    OutputShaftValue: OutputShaft.value,
    handOfAssembly: handOfAssembly.options[handOfAssembly.selectedIndex].text.replace(/^.*? - /, ''),
    handOfAssemblyValue: handOfAssembly.value,
    motorAdaptor: motorAdaptor.options[motorAdaptor.selectedIndex].text.replace(/^.*? - /, ''),
    motorAdaptorValue:motorAdaptor.value,
    specialFeature: specialFeature.options[specialFeature.selectedIndex].text.replace(/^.*? - /, ''),
    specialFeatureValue:specialFeature.value,
    speed:speed.replace(/^.*? - /, ''),
    speedValue:speed.charAt(0)
  };
this.rgSharedService.setProductSpecification(prodDetails);
  // console.log("Product Details", prodDetails);
}

}
